import { connectNavTestIds } from "@/lib/data-test-ids/components.data-test-ids";

interface NimbleLogoProps {
  className?: string;
}

export default function NimbleLogo({ className }: NimbleLogoProps) {
  return (
    <svg
      width="45"
      height="48"
      viewBox="0 0 45 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="Nimble Logo"
      data-testid={connectNavTestIds.LOGO}
    >
      <path
        d="M38.8844 5.02008C38.9017 5.02856 38.9167 5.04096 38.9283 5.05628C38.9398 5.07161 38.9477 5.08944 38.9512 5.10836C38.9547 5.12727 38.9537 5.14674 38.9484 5.16522C38.943 5.18369 38.9334 5.20066 38.9204 5.21477L28.5031 15.341L28.3763 15.3669L14.4611 11.2766C14.4445 11.2675 14.4302 11.2548 14.4191 11.2395C14.408 11.2241 14.4005 11.2065 14.3971 11.1878C14.3936 11.1692 14.3944 11.15 14.3992 11.1317C14.4041 11.1134 14.413 11.0964 14.4252 11.0819L24.9231 1.06663L25.0538 1.04565L38.8844 5.02008Z"
        className="fill-brand-teal"
      />
      <path
        d="M38.9602 5.13458C38.967 5.07325 38.8713 5.01828 38.7548 5.11177L28.4074 15.166L28.355 15.24L31.73 29.088C31.7232 29.1494 31.8189 29.2044 31.8713 29.1303L42.3799 19.1783L42.4329 19.0999L38.9602 5.13458Z"
        className="fill-brand-teal-dark"
      />
      <path
        d="M6.62535 30.9256V47.7439C6.62535 47.7991 6.58058 47.8439 6.52535 47.8439H0.0999998C0.0447713 47.8439 0 47.7991 0 47.7439V20.3383C0 20.2831 0.0447715 20.2383 0.1 20.2383H6.80486C6.84025 20.2383 6.87301 20.257 6.89099 20.2875L16.9577 37.3538V20.3383C16.9577 20.2831 17.0025 20.2383 17.0577 20.2383H23.4831C23.5383 20.2383 23.5831 20.2831 23.5831 20.3383V47.7439C23.5831 47.7991 23.5383 47.8439 23.4831 47.8439H16.9352C16.9002 47.8439 16.8678 47.8256 16.8497 47.7957L6.62535 30.9256Z"
        className="fill-brand-ink"
      />
    </svg>
  );
}
